// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vuv8","tabsBox":"styles_tabsBox__3SXtY","createButton":"styles_createButton__CdAeU"};